module.exports = __webpack_public_path__ + "img/43.06364b3.jpg";